import { AnalysisEffects } from './analysis.effect';
export * from './analysis.effect';

export const effects: any[] = [AnalysisEffects];
